<template>
  <div>
    <QueryFrame
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count="count"
    >
      <div slot="queryParams" class="queryContainer">
				<div class="queryItem">
          <label>领用单号:</label>
          <lk-input class="item" v-model="query.orderNo" clearable placeholder="请输入" />
        </div>
        <div class="queryItem">
          <label>商品搜索:</label>
          <lk-input class="item" v-model="query.nameMix" clearable placeholder="可按商品名、通用名、编码、助记码搜索" />
        </div>
        <div class="queryItem">
          <label>生产企业:</label>
          <lk-input class="item" v-model="query.producer" clearable placeholder="生产厂家" />
        </div>
				<div class="queryItem">
          <label>领用时间:</label>
          <timeStampDatePicker type='daterange'  placeholder=" 请选择" class="item" v-model.trim='query.saleTimeRange' ></timeStampDatePicker>
        </div>
        <div class="queryItem" v-if="roleType!==2">
          <label >门店:</label>
          <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>医院名称:</label>
          <lk-input class="item" v-model="query.prescriptionHospital" clearable placeholder="请输入" />
        </div>
        <div class="queryItem">
          <label>患者姓名:</label>
          <lk-input class="item" v-model="query.patientName" clearable placeholder="请输入" />
        </div>
        <div class="queryItem">
          <label>领用者:</label>
          <lk-input class="item" v-model="query.buyerName" clearable placeholder="请输入" />
        </div>
        <div class="queryItem">
          <label>援助方式:</label>
          <lk-select class="item" v-model="query.aidTypeName" clearable>
            <lk-option v-for="item in aidTypeList" :value="item.id" :key="item.id">
            {{ item.name }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="search-btn" @click="handleSearch(false)">查询</lk-button>
          <lk-button @click="clear">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <DownloadButton  class="btn" @on-click='handleExport' v-if="handlePermission('aidSaleRecordExport')"></DownloadButton>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import aid from '../../services/aid';
import utils from '../../libs/utils';
import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'unpackSale',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton,
  },
  data() {
    return {
      aidTypeList: [
        { id: '低保', name: '低保' },
        { id: '低收入', name: '低收入' },
      ],
      summary: {},
      query: {
        saleTimeRange: [],
      },
      columns: [
        {
          title: '序号', key: 'index', minWidth: 116, tooltip: true, fixed: 'left', type: 'index',
        },
        {
          title: '领用单号', key: 'saleOrderDetailOrderNo', minWidth: 116, tooltip: true,
        },
        {
          title: '行号', key: 'saleOrderDetailLineNum', minWidth: 116, tooltip: true,
        },
        {
          title: '通用名', key: 'saleOrderDetailApprovedDrugNames', minWidth: 116, tooltip: true,
        },
        {
          title: '商品名', key: 'saleOrderDetailGoodsName', minWidth: 116, tooltip: true,
        },
        {
          title: '商品编码', key: 'saleOrderDetailDrugSerialCode', minWidth: 116, tooltip: true,
        },
        {
          title: '规格', key: 'saleOrderDetailSpecifications', minWidth: 116, tooltip: true,
        },
        {
          title: '剂型', key: 'saleOrderDetailDosageForm', minWidth: 116, tooltip: true,
        },
        {
          title: '单位', key: 'saleOrderDetailGoodsUnit', minWidth: 116, tooltip: true,
        },
        {
          title: '批号', key: 'saleOrderDetailGoodsLot', minWidth: 116, tooltip: true,
        },
        {
          title: '生产日期', key: 'saleOrderDetailManufactureDate', minWidth: 116, tooltip: true,
        },
        {
          title: '有效日期', key: 'saleOrderDetailExpireDate', minWidth: 116, tooltip: true,
        },
        {
          title: '生产企业', key: 'saleOrderDetailManufacturer', minWidth: 116, tooltip: true,
        },
        {
          title: '患者', key: 'salePrescriptionPatientName', minWidth: 116, tooltip: true,
        },
        {
          title: '患者编码', key: 'salePrescriptionPatientCode', minWidth: 116, tooltip: true,
        },
        {
          title: '医院', key: 'salePrescriptionPrescriptionHospital', minWidth: 116, tooltip: true,
        },
        {
          title: '医生', key: 'salePrescriptionPrescriptionDoctor', minWidth: 116, tooltip: true,
        },
        {
          title: '援助方式', key: 'salePrescriptionAidTypeName', minWidth: 116, tooltip: true,
        },
        {
          title: '数量', key: 'saleOrderDetailGoodsCount', minWidth: 116, tooltip: true,
        },
        {
          title: '产品追溯码', key: 'saleOrderDetailTraceCode', minWidth: 116, tooltip: true,
        },
        {
          title: '领用者', key: 'saleBuyerInfoBuyerName', minWidth: 116, tooltip: true,
        },
        {
          title: '领用日期', key: 'saleOrderDetailCreateTime', minWidth: 116, tooltip: true,
        },
        {
          title: '审方药师', key: 'salePrescriptionCreateUserName', minWidth: 116, tooltip: true,
        },
        {
          title: '调配人', key: 'salePrescriptionAllocaterName', minWidth: 116, tooltip: true,
        },
        {
          title: '复核人', key: 'salePrescriptionReviewerName', minWidth: 116, tooltip: true,
        },
        {
          title: '实际单价', key: 'saleOrderDetailRealPrice', minWidth: 130, tooltip: true,
        },
        {
          title: '金额', key: 'saleOrderDetailAmountDisplay', minWidth: 116, tooltip: true,
        },
        {
          title: '经办人', key: 'saleOrderDetailCreateUserName', minWidth: 116, tooltip: true,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleExport() {
      this.paramsChange();
      this.params = utils.deletePageAndSize(this.params);
      this.params.queryCondition = utils.getQueryCondition('.queryContainer');

      aid.aidSaleRecordExport(this.params)
        .then((res) => {
          if (res.data.error) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },

    paramsChange() {
      if (this.params.saleTimeRange && this.params.saleTimeRange.length === 2) {
        this.params.createTimeStart = this.params.saleTimeRange[0];
        this.params.createTimeEnd = this.params.saleTimeRange[1];
      }
      delete this.params.saleTimeRange;
    },
    getData() {
      this.params.size = this.size;
      this.params.page = this.page;
      this.paramsChange();
      aid.getAidSaleRecordList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.saleOrderDetailManufactureDate = utils.exchangeTime(result.saleOrderDetailManufactureDate);
            result.saleOrderDetailExpireDate = utils.exchangeTime(result.saleOrderDetailExpireDate);
            result.saleOrderDetailCreateTime = utils.exchangeTime(result.saleOrderDetailCreateTime);
            this.tableData.push(result);
          });
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        saleTimeRange: [],
      };
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店', key: 'saleOrderDetailStoreName', minWidth: 116, tooltip: true,
      });
    }
    this.handleSearch(true);
  },
};
</script>

<style lang="less" scoped>
.btn{
  margin-bottom: 12px
}
</style>
